import * as content from "./site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const KEY_TO_EXPORT = {
  site: "SITE",
  crisis: "CRISIS",
  home: "HOME_PAGE",
  about: "ABOUT_PAGE",
  event: "EVENT",
  registration: "REGISTRATION",
  faqs: "WALK_FAQS",
  resources: "RESOURCES",
  gallery: "GALLERY",
  news: "ANNOUNCEMENTS",
  contact: "CONTACT",
  volunteer: "VOLUNTEER",
  sponsor: "SPONSOR",
  donations: "DONATIONS",
  seo: "SEO",
  images: "IMAGES",
};

function applyValue(target, value) {
  if (Array.isArray(target)) {
    target.splice(0, target.length, ...(Array.isArray(value) ? value : []));
  } else if (target && typeof target === "object" && value && typeof value === "object") {
    Object.keys(target).forEach((k) => delete target[k]);
    Object.assign(target, value);
  }
}

// Loads published content (or drafts, in admin preview mode) and merges
// it over the built-in defaults before the app renders.
export async function loadContent() {
  const params = new URLSearchParams(window.location.search);
  const wantsPreview = params.get("preview") === "1";
  const token = localStorage.getItem("tj_admin_token");
  let url = `${API}/content`;
  let headers = {};
  if (wantsPreview && token) {
    url = `${API}/admin/preview`;
    headers = { Authorization: `Bearer ${token}` };
    window.__TJ_PREVIEW = true;
  }
  try {
    const res = await fetch(url, { headers });
    if (!res.ok) return;
    const data = await res.json();
    for (const [key, exportName] of Object.entries(KEY_TO_EXPORT)) {
      const value = data[key];
      if (value == null) continue;
      applyValue(content[exportName], value);
    }
  } catch {
    // network or API issue — the built-in defaults still render
  }
}
